import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Select from 'react-select';
import { searchIconLarge as SearchIconLarge } from '../../icons';
import './healthCareFilter.css';

// TODO: make this variable as state inside component.
// TODO: change variables name => make them relative.
const speciality = [
  { value: 'neurologist', label: 'neurologist' },
  { value: 'dental', label: 'dental' },
  { value: 'sychologist', label: 'sychologist' }
];
const options2 = [
  { value: 'hydrabad', label: 'hydrabad' },
  { value: 'islamabad', label: 'islamabad' },
  { value: 'karachi', label: 'karachi' }
];
const options3 = [
  { value: 'hashwani', label: 'hashwani' },
  { value: 'civil', label: 'civil' },
  { value: 'jinnah', label: 'jinnah' }
];

// INFO: how we decide states in a component.
// 1- data that is changing.
// 2- user inputs
// 3- data not part of our frontend (API)
function HealthCareFilter() {
  const [selectedOption, setSelectedOption] = useState(null);
  // const [ conditions, setConditions ] = useState([]);
  // const [ user, setUser ] = useState({});
  // const [ phone, setPhone ] = useState('');

  return (
    <section className="healthCareFilter">
      <Container>
        <form>
          <div className="filter-box">
            <Select
              className="select"
              placeholder="Condition, speciality..
              "
              defaultValue={selectedOption}
              onChange={setSelectedOption}
              options={speciality}
            />
            <Select
              className="select"
              placeholder="city
              "
              defaultValue={selectedOption}
              onChange={setSelectedOption}
              options={options2}
            />
            <Select
              className="select"
              placeholder="Doctors, Hospital..
              "
              defaultValue={selectedOption}
              onChange={setSelectedOption}
              options={options3}
            />
            <button type="button" className="search-btn">
              <SearchIconLarge />
            </button>
          </div>
        </form>
      </Container>
    </section>
  );
}

export default HealthCareFilter;
